import { useGA4 } from "../../hooks/trackers/ga4.hook";

export default function GA4({ id, enableTracking, cookieSettings }) {
  useGA4(id, enableTracking, cookieSettings === "unrestricted");
  return "";
}
